import {fromPairs} from 'lodash';

export default {
  check: argDocument => {
    const context = argDocument || document;
    const location = context.location;
    const hash = new URL(location).hash;
    const origin = fromPairs(hash.split('&').map(e => e.split('='))).state;

    const origins = process.env.VUE_APP_ALLOWED_ORIGINS.split(' ');

    const exists = origins.includes(origin);
    if (exists) {
      return origin;
    }
    return exists;
  },
  isAllowed: domain => {
    return process.env.VUE_APP_ALLOWED_ORIGINS.split(' ').includes(domain);
  }
};
